export default __webpack_public_path__ + "static/media/header2.101e9e43.jpg";